var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHand4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9728 14.9532L10.9745 11.9999M10.9745 11.9999C10.9736 11.0738 11.6473 10.3621 12.4773 10.3612C13.3083 10.3612 13.9819 11.0728 13.9819 12L13.9835 13M10.9745 11.9999L10.9923 6.89905C10.9923 5.97188 10.3187 5.22025 9.48771 5.22025H9.4862C8.65615 5.22122 7.984 5.97282 7.98486 6.89898C7.99197 13.4552 7.99142 16.0122 7.9832 16.0103C6.60515 16.0103 5.56185 14.0567 3.75285 14.0567C1.9438 14.0567 1.64025 15.1299 2.36312 16.0797C2.84504 16.7128 7.9832 23 7.9832 23H15.9999C18.209 23 19.9998 21.2092 19.9999 19.0001L20 14.1788C20 13.2516 19.3264 12.5 18.4954 12.5H18.4939C17.6639 12.501 16.9917 13.2526 16.9926 14.1787M13.9835 13V14.9532M13.9835 13C13.9827 12.0738 14.6548 11.3222 15.4849 11.3212H15.4864C16.3173 11.3212 16.9909 12.0728 16.9909 13L16.9926 14.1787M16.9926 14.1787L16.9909 14.9532M14.4165 6.25H12.9165M5.91649 6.25H4.12045M13.1288 2.53771L11.8914 3.77514M5.70419 2.53771L6.94163 3.77514M9.41649 1V2.75",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand4);
export default __webpack_public_path__ + "static/media/hand4.4c3ac2576b45c416dd817e02279d9686.svg";
export { ForwardRef as ReactComponent };